import {useEffect, useState} from 'react';
import { useI18n } from '../../../data/hooks/i18nHooks';

/**
 * Verifies the given code and returns the summary and error.
 *
 * @param {string} code - The code to be verified.
 * @return {Array} An array containing the summary and error.
 */
export function useCodeVerification(code) {
    const [error, setError] = useState(null),
        [summary, setSummary] = useState(null),
        i18n = useI18n();

    // verify code
    useEffect(() => {
        let waitingForResponse = true;

        async function verifyCode() {
            app.store.dispatch(app.actions.ui.busy());
            try {
                let response = await app.api.misc.verifyCode(code);
                if (waitingForResponse) {
                    if (response.added) {
                        app.store.dispatch(app.actions.session.clearPrefill());
                        app.history.push('/events/' + response.event_id);
                    } else if (response.error) {
                        if (response.error == 'code already used') {
                            setError({message: i18n['error.event-code-used'], code_used: true});
                        } else {
                            setError({message: i18n['error.not.valid.event.code'], code_used: false});
                        }
                    } else {
                        setError(null);
                        setSummary(response.summary);

                        // store until we add the event
                        app.store.dispatch(app.actions.session.prefill(response));
                    }
                }
            } catch (err) {
                console.log(err);
                setError({message: i18n['error.not.valid.event.code']});
                app.store.dispatch(app.actions.session.clearPrefill());
            }
            app.store.dispatch(app.actions.ui.free());
        }
        verifyCode();

        return () => (waitingForResponse = false);
    }, []);

    return [summary, error];
}
